module.exports = __webpack_public_path__ + "img/defaultImg2.adedcccf.png";